module.exports = "/next-static/_next/static/images/block_image_one_1x-4505fa84cd949c79de9057f74be0333c.webp";